'use client';

import { jsxs, jsx } from "react/jsx-runtime";
import { Text } from "../../atoms/Text/Text.js";
import { classNames } from "../../utils/styles/classNames.js";
import { MenuItemStatus } from "../../atoms/MenuItem/MenuItem.Status.js";
import { getLabelId, getCaptionId } from "../../atoms/MenuItem/utils/constants.js";
import { variantColor } from "../../atoms/MenuItem/utils/typed-constants.js";
import { layout, labelWrapper, label, suffix, contentGap, content } from "./MenuItemWithSymbols.css.js";
function MenuItemWithSymbolsContent(props) {
  const {
    leadSymbol,
    endSymbol,
    label: label$1,
    status,
    caption,
    disabled,
    variant,
    a11yLabel,
    id
  } = props;
  const hasStatus = !!status?.label;
  const hasSuffix = hasStatus || !!endSymbol;
  return /* @__PURE__ */ jsxs("span", { className: layout[caption ? "withCaption" : "withoutCaption"], children: [
    leadSymbol,
    /* @__PURE__ */ jsxs("span", { className: classNames(content, hasStatus && contentGap), children: [
      a11yLabel && /* @__PURE__ */ jsx(Text, { id: getLabelId(id), visuallyHidden: true, children: a11yLabel }),
      /* @__PURE__ */ jsxs("span", { className: labelWrapper, children: [
        /* @__PURE__ */ jsx(
          Text,
          {
            "aria-hidden": a11yLabel ? "true" : void 0,
            as: "span",
            className: label,
            color: disabled ? "onLight.disabled.muted" : variantColor[variant || "default"],
            id: a11yLabel ? void 0 : getLabelId(id),
            variant: "body.base",
            children: label$1
          }
        ),
        hasSuffix && /* @__PURE__ */ jsxs("span", { className: suffix, children: [
          hasStatus && /* @__PURE__ */ jsx(MenuItemStatus, { ...props }),
          endSymbol
        ] })
      ] }),
      caption && /* @__PURE__ */ jsx(
        Text,
        {
          color: "onLight.text.tertiary",
          id: getCaptionId(id),
          variant: "body.xs",
          children: caption
        }
      )
    ] })
  ] });
}
export {
  MenuItemWithSymbolsContent
};
